import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getResumeDetails } from "../../slice/workerResumeSlice";
import WorkerHeader from "../../../worker-header/components/index";
import WorkerFooter from "../../../worker-footer/components/index"

const WorkerUserResumeDetails = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const { resumeDetails, loading, error } = useSelector(
        (state) => state.workerResume
    );

    useEffect(() => {
        dispatch(getResumeDetails(id));
    }, [id, dispatch]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) return <p className="text-danger">{error}</p>;
    if (!resumeDetails) return null;

    const resume = resumeDetails;
    const user = resume?.user?.[0];

    if (!user) {
        return <p className="text-danger">User data not found</p>;
    }

    const skillsArray = resumeDetails?.skills?.split(",") || [];

    return (
        <>
            <WorkerHeader />
            <main className="overflow-hidden">
                <section className="homepad" style={{ minHeight: "60vh" }}>
                    <div className="container">
                        <div className="row d-flex align-items-stretch">
                            <div className="col-lg-8 services-listpage">
                                <div className="form-section rounded p-3 p-sm-4">
                                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                                        Resume Details
                                    </h4>
                                    <div className="card shadow-sm p-4">
                                        <div className="d-flex justify-content-between align-items-start mb-3">
                                            <h2 className="text-primary text-uppercase">{user.first_name || "-"} {user.last_name || "-"}</h2>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-4 mb-2">
                                                <strong>Email:</strong> {user.email || "-"}
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <strong>Phone:</strong> {user.phone || "-"}
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <strong>Date of Birth:</strong>{" "}
                                                {user?.date_of_birth
                                                    ? new Date(user.date_of_birth).toLocaleDateString("en-US")
                                                    : "-"}

                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-4 mb-2">
                                                <strong>Support position:</strong> {user.support_position || "-"}
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <strong>Worker Type:</strong> {user.worker_type || "-"}
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <strong>Employment Type:</strong> {user.employment_type || "-"}
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-4 mb-2">
                                                <strong>State:</strong> {user.states || "-"}
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-start mb-3">
                                            <h4 className="text-primary text-uppercase border-bottom pb-2">Resume Details</h4>
                                        </div>
                                        <div className="card shadow-sm p-4">

                                            {/* Header */}
                                            <div className="border-bottom pb-3 mb-4">
                                                <h4 className="text-primary mb-1">{resumeDetails.title}</h4>
                                                <h5 className="text-muted">{resumeDetails.headline}</h5>
                                            </div>

                                            {/* Summary */}
                                            <div className="mb-4">
                                                <h5 className="text-muted">Professional Summary</h5>
                                                <p>{resumeDetails.summary}</p>
                                            </div>

                                            {/* Skills */}
                                            <div className="mb-4">
                                                <h5 className="text-muted">Skills</h5>
                                                <div>
                                                    {skillsArray?.map((skill, index) => (
                                                        <span
                                                            key={index}
                                                            className="badge bg-primary me-2 mb-2"
                                                        >
                                                            {skill.trim()}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Experience */}
                                            <div className="mb-4">
                                                <h5 className="text-muted">Work Experience</h5>

                                                {resumeDetails?.experience?.length > 0 ? (
                                                    resumeDetails.experience.map((exp) => (
                                                        <div key={exp.id} className="border rounded p-3 mb-3">
                                                            <div className="d-flex justify-content-between">
                                                                <h6 className="mb-0">{exp.job_title}</h6>
                                                                <small className="text-muted">
                                                                    {exp.start_date} – {exp.end_date || "Present"}
                                                                </small>
                                                            </div>
                                                            <p className="mb-1 fw-semibold">{exp.company}</p>
                                                            <p className="mb-0">{exp.description}</p>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p className="text-muted">No experience added.</p>
                                                )}
                                            </div>

                                            {/* Education */}
                                            <div>
                                                <h5 className="text-muted">Education & Certifications</h5>

                                                {resumeDetails?.education?.length > 0 ? (
                                                    resumeDetails.education.map((edu) => (
                                                        <div key={edu.id} className="border rounded p-3 mb-3">
                                                            <div className="d-flex justify-content-between">
                                                                <h6 className="mb-0">{edu.school_or_cert}</h6>
                                                                <small className="text-muted">
                                                                    {edu.start_year} – {edu.end_year}
                                                                </small>
                                                            </div>
                                                            <p className="mb-1 fw-semibold">
                                                                {edu.degree} ({edu.field})
                                                            </p>
                                                            <p className="mb-0">{edu.description}</p>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p className="text-muted">No education details added.</p>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 mt-4 pt-4">

                                <div className="support-card text-white bg-primary rounded15 p-4 mt-4">
                                    <div className="p-md-2">
                                        <h5 className="font-weight-semibold font-size-18 mb-3">Need Help?</h5>
                                        <p className="mb-3">Reach out to our support executive<br />for any help</p>
                                        <div className="phone-number my-4">
                                            <img src="/assets/images/phone-call-01.svg" className="img-fluid" alt="" />
                                            <span>+91-6353385120</span>
                                        </div>
                                        <a href="https://wa.me/916353385120" target="_blank" className="whatsapp-button">
                                            <img src="/assets/images/chat-whatsapp-icon.svg" className="img-fluid" alt="" />
                                            Chat on Whatsapp
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <WorkerFooter />
        </>
    );
};

export default WorkerUserResumeDetails;
